module.exports = __webpack_public_path__ + "slide1.a46ec41cb60800ac85e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide1.jpg
// module id = ./src/assets/images/private/home/slide1.jpg
// module chunks = main